export default defineNuxtPlugin(() => {
  import('cropperjs');
});
